<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref } from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { usePayment } from "@/composables/usePayment"
import { useGender } from "@/app/Checkout/composables/useGender"
import { useCheckout } from "@/app/Checkout/composables/useCheckout"
import { useAddresses } from "@/app/Checkout/composables/useAddresses"

const store = useStore()
const route = useRoute()
const router = useRouter()
const selectedAddressId = ref(null)
const { getGenderLabel } = useGender()
const { getPaymentMethods } = usePayment()
const { setInvoiceAddress, setShippingAddress } = useCheckout()
const { mapAddressID, enrichedAddresses, getAddressString, isBillingAddressSame } = useAddresses()

selectedAddressId.value = mapAddressID(route.query?.type)

const goToEdit = (id) => {
  router.push({
    params: { id },
    name: 'EditAddress',
  })
}

const handleSelect = async (address) => {
  if (address.is_invalid) {
    goToEdit(address.id)
  } else {
    selectedAddressId.value = address.id

    if (route.query?.type === 'delivery_address') {
      const response = await setShippingAddress(address.id, isBillingAddressSame.value)

      if (response.redirect) {
        window.location.href = response.url

        return
      } else {
        await getPaymentMethods()
      }
    } else {
      await setInvoiceAddress(address.id)
    }

    store.commit("checkout/SET_IS_BILLING_ADDRESS_SAME", getAddressString('invoice_address') === getAddressString('delivery_address'))

    router.push({
      name: 'Checkout',
    })
  }
}
</script>
